import React, { createContext, useCallback, useContext, useState } from 'react';

const ApprovalGuideModalContext = createContext(null);

export const useApprovalGuideModal = () => {
  const context = useContext(ApprovalGuideModalContext);
  if (!context) {
    throw new Error('useApprovalGuideModal must be used within a ApprovalGuideModalProvider');
  }
  return context;
};

export function ApprovalGuideModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [docTitle, setDocTitle] = useState(null); // 문서 제목 상태 추가

  // open 함수가 title을 인자로 받도록 수정
  const open = useCallback((title = null) => {
    setDocTitle(title);
    setIsOpen(true);
  }, []);

  // close 함수가 title 상태도 초기화하도록 수정
  const close = useCallback(() => {
    setIsOpen(false);
    setDocTitle(null);
  }, []);

  // docTitle을 value에 추가
  const value = { isOpen, docTitle, open, close };

  return (
    <ApprovalGuideModalContext.Provider value={value}>
      {children}
    </ApprovalGuideModalContext.Provider>
  );
}
